import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  watch: {
    '$route': function() {
      const html = document.querySelector('html');
      if(html) {
        html.style.overflowY = 'scroll'
        html.style.touchAction = 'unset';
        html.style.padding = '0';
      }      
    }
  },
  render: h => h(App),
}).$mount('#app')
